import { render, staticRenderFns } from "./PageList.vue?vue&type=template&id=6988e418&scoped=true"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"
import style0 from "./PageList.vue?vue&type=style&index=0&id=6988e418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988e418",
  null
  
)

export default component.exports